import React from "react";
import Icon from "../../common/Icon/Icon";
import Typography from "../../common/Typography/Typography";
import styles from "./NotificationItem.module.css";

enum StatusColor {
    error = "text-plum-500 fill-plum-500",
    warning = "text-mustard-300 fill-mustard-300",
    success = "text-mint-300 fill-mint-300",
    info = "text-velvet-500 fill-velvet-500",
}

enum StatusIcons {
    error = "warning",
    warning = "warning",
    success = "success",
    info = "info",
}

interface Props {
    status: "error" | "warning" | "success" | "info";
    title: string;
    description: string;
    date: string;
    href: string;
}

const NotificationItem = ({ status, title, description, href, date }: Props) => (
    <div className={styles.notificationItem}>
        <div className="space-y-0.25">
            <div className="flex gap-0.5">
                <Icon icon={StatusIcons[status]} className={StatusColor[status]} width={18} height={18} />
                <Typography as="h5" variant="label" className={`grow ${StatusColor[status]}`}>
                    {title}
                </Typography>
                <Typography as="span" variant="note" color="pine">
                    {date}
                </Typography>
            </div>
            <Typography as="p" variant="meta">
                {description}
            </Typography>
        </div>
        <a href={href} title="Click to view notification" className={styles.hitBox}>
            Click to view notification
        </a>
    </div>
);

export default NotificationItem;
